import { DeclarationHighValueGroupType } from '@e-origin/shared';

import { CHARGES_HIDDEN, CONTAINER_ITEMS_NO_SEALS, HIDDEN_FOR_H2 } from '../fields.base';
import { FinalizeFormValues, Variant } from '../types';
import { isVatDeferredPaymentInvalid, VAT_D_PAYMENT_WARNING } from '../validation';

const H2 = DeclarationHighValueGroupType.H2;

const vatDeferredPaymentError = (values: FinalizeFormValues) =>
  isVatDeferredPaymentInvalid(values.messageInfo as { methodOfPaymentVAT?: string; methodOfPayment?: string; deferredPayment?: string })
    ? VAT_D_PAYMENT_WARNING
    : undefined;

export const nlImport: Variant = {
  'consignment.countryOfDispatch': { rules: [{ when: { txClass: ['B2B'] }, then: { present: true } }] },

  'goodShipmentGlobal.preference': { present: true },
  'messageInfo.methodOfPayment': { present: true, rules: HIDDEN_FOR_H2 },
  'messageInfo.deferredPayment': { present: true, rules: HIDDEN_FOR_H2 },
  'valuationInformationTaxes.valuationMethod': { present: true, rules: HIDDEN_FOR_H2 },

  'messageInfo.methodOfPaymentVAT': { present: true, rules: HIDDEN_FOR_H2, validate: vatDeferredPaymentError },

  'messageInfo.deferredPaymentVAT': {
    rules: [{ when: { not: { group: H2 } }, then: { present: true } }],
    validate: vatDeferredPaymentError,
  },
  'valuationInformationTaxes.valuationAdjustment.valuationIndicators': { rules: [{ when: { not: { group: H2 } }, then: { present: true } }] },

  'declarationGlobal.totalAmountInvoiced': { rules: [{ when: { group: H2 }, then: { present: false } }] },
  'goodShipmentGlobal.invoiceCurrency': { rules: [{ when: { group: H2 }, then: { present: false } }] },

  'messageInfo.security': { amendmentLocked: true },
  'consignment.customsOfficePresentation.referenceNumber': { amendmentLocked: true },
  'consignment.customsSupervisingOffice.referenceNumber': { amendmentLocked: true },
  customer: { amendmentLocked: true },

  'transportInformation.arrivalTransportMeans.identificationNumber': { rules: [{ when: { not: { group: H2 } }, then: { present: true } }] },
  'transportInformation.arrivalTransportMeans.typeOfIdentification': { rules: [{ when: { not: { group: H2 } }, then: { present: true } }] },

  chargesDeliveryTerms: { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.CustomsCharges.charges': { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.CustomsCharges.currency': { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.VATcharges.charges': { present: true, rules: CHARGES_HIDDEN },
  'valuationInformationTaxes.chargesimport.VATcharges.currency': { present: true, rules: CHARGES_HIDDEN },

  'transportInformation.transportEquipment.containers': { items: CONTAINER_ITEMS_NO_SEALS },
};
